import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { statisticsSearchSchema } from '../../types/statisticsSearchSchema';
import { StatisticsPage } from '../statistics/StatisticsPage';

export const Route = createFileRoute('/_app/statistics')({
    component: StatisticsPage,
    validateSearch: zodSearchValidator(statisticsSearchSchema),
});
